module.exports = "/images/cashback.svg?b5b2b5aaa56df0965fe7cc797b83b207";